import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UsergroupProfile, UsergroupQuality } from 'src/app/users/models';

@Component({
    selector: 'app-skill-tag',
    templateUrl: './skill-tag.component.html',
    styleUrls: ['./skill-tag.component.scss'],
    standalone: false
})
export class SkillTagComponent {
  // ---------- INPUTS ----------
  @Input({ required: true }) profile!: UsergroupProfile;
  @Input() groupId?: number;   // ✅ optional
  @Input() canEditUsers = false;
  @Input() isSortable = false;

  // ---------- OUTPUTS ----------
  @Output()
  qualityLevelChange = new EventEmitter<{
    groupId?: number;
    profile: UsergroupProfile;
    qualityId: number;
    level: string;
  }>();

  @Output()
  removeQuality = new EventEmitter<{
    groupId?: number;
    profile: UsergroupProfile;
    qualityId: number;
  }>();

  @Output()
  addSkills = new EventEmitter<{
    groupId?: number;
    profile: UsergroupProfile;
  }>();

  // ---------- EVENTS ----------
  qualityLevelChanged(qualityId: number, level: string) {
    this.qualityLevelChange.emit({
      groupId: this.groupId,
      profile: this.profile,
      qualityId,
      level
    });
  }

  removeQualityClicked(qualityId: number) {
    this.removeQuality.emit({
      groupId: this.groupId,
      profile: this.profile,
      qualityId
    });
  }

  addSkillsClicked() {
    this.addSkills.emit({
      groupId: this.groupId,
      profile: this.profile
    });
  }


  // ---------- HELPERS ----------
  hasSkills(profile: UsergroupProfile): boolean {
    return profile.skills?.some(s => s.qualities?.length) ?? false;
  }

  getAllQualities(profile: UsergroupProfile): UsergroupQuality[] {
    return profile.skills?.flatMap(s => s.qualities ?? []) ?? [];
  }
}